import React from 'react';
import { motion } from 'framer-motion';
import { Play } from 'lucide-react';
import { LazyImage } from './LazyImage';
import { getImageUrl } from '../lib/supabase';
interface ProjectCardProps {
  title: string;
  category: string | string[];
  year: string;
  thumb_path?: string;
  media_type?: 'image' | 'video';
  index: number;
  height?: string;
}
export function ProjectCard({
  title,
  category,
  year,
  thumb_path,
  media_type = 'image',
  index,
  height = 'medium'
}: ProjectCardProps) {
  const displayImage = getImageUrl(thumb_path);
  const categories = Array.isArray(category) ? category : [category];
  const isVideoWithCategory = categories.includes('Video');
  const isGif = displayImage?.toLowerCase().includes('.gif') || false;
  return <motion.div initial={{
    opacity: 0,
    y: 50
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.6,
    delay: index * 0.1
  }} className="group relative w-full cursor-pointer break-inside-avoid" data-id="element-176">
      <div className="relative overflow-hidden bg-neutral-900 rounded-sm" data-id="element-177">
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-all duration-500 z-10" data-id="element-178" />

        {isVideoWithCategory && <div className="absolute inset-0 flex items-center justify-center z-20 pointer-events-none" data-id="element-179">
            <motion.div initial={{
          scale: 1
        }} whileHover={{
          scale: 1.1
        }} className="w-16 h-16 rounded-full bg-white/90 flex items-center justify-center shadow-lg" data-id="element-180">
              <Play className="w-8 h-8 text-black fill-black ml-1" data-id="element-181" />
            </motion.div>
          </div>}

        {displayImage ? <motion.div whileHover={isGif ? {} : {
        scale: 1.05
      }} transition={{
        duration: 0.6,
        ease: [0.33, 1, 0.68, 1]
      }} data-id="element-182">
            <LazyImage src={displayImage} alt={title} className="w-full h-auto" data-id="element-183" />
          </motion.div> : <div className="w-full aspect-[4/3] flex items-center justify-center bg-neutral-800" data-id="element-184">
            <p className="text-white/40 text-sm" data-id="element-185">No image</p>
          </div>}
      </div>
    </motion.div>;
}